// frontend/src/index.js

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Se envuelve el renderizado inicial en un setTimeout para retardar el arranque
// de React. Esto evita el conflicto con extensiones del navegador que modifican
// la página al cargar.
setTimeout(() => {
  root.render(
    // Como medida de precaución, dejamos StrictMode desactivado por ahora,
    // ya que puede intensificar este tipo de errores de renderizado.
    // <React.StrictMode>
      <App />
    // </React.StrictMode>
  );
}, 50); // Un retardo de 50ms es suficiente para estabilizar la carga.